import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CardActionArea, Grid, Stack, TextField } from '@mui/material';
import './portal.css';
import { Girl } from '@mui/icons-material';

const MyCardAction = (props) => {
    return (
        <CardActionArea
            // data-active={props.tipo === props.name}
            data-active={props.tipo === props.name ? '' : undefined}
            sx={{
                height: '100%',
                '&[data-active]': {
                    backgroundColor: 'action.selected',
                    '&:hover': {
                        backgroundColor: 'action.selectedHover',
                    },
                },
            }}
            onClick={() => props.action(props.name)}
        >
            {props.children}
        </CardActionArea>
    )
}
// export default function TipoLayout(props) {
const TipoLayout = React.forwardRef((props, ref) => {

    const { setLayout, layout } = props;

    function montaDadoFilho(tipo) {
        if (tipo === 'portal') {
            setLayout({
                tipo: 'portal',
                header: 'Header',
                left: 'Left',
                body: 'Body',
                rigth: 'Rigth',
                footer: 'Footer'
            });

        } else if (tipo === 'linha') {
            setLayout({
                tipo: 'linha',
                linha: 'Linha'
            });
        } else if (tipo === 'coluna') {
            setLayout({
                tipo: 'coluna',
                coluna: 'Coluna'
            });
        } else {
            alert('Não implementado: ' + tipo)
        }
        // return layout;
    }

    function handleClick(tp) {
        setLayout({
            ...layout,
            tipo: tp
        });
        montaDadoFilho(tp)
    }

    const onChangeLayout = (e) => {
        let dado = {...layout};
        dado[e.target.id].pagina = e.target.value
        setLayout(dado)
    }
    const onChangeLayoutRegra = (e) => {
        let dado = {...layout};
        dado[e.target.id].regra = e.target.value
        setLayout(dado)
    }
    function MontaFormTipo() {

        if (layout.tipo === 'portal') {
            return (
                <Stack spacing={2} sx={{ width: '100%' }} >
                    <div>
                        <TextField
                            value={layout.header.pagina}
                            id="header"
                            onChange={onChangeLayout}
                            label="Header"
                            size='small'
                            variant="outlined"
                            sx={{ width: '70%' }}
                            helperText="Indique nome da pagina que vai ficar o cabeçalho"
                        />
                        <TextField
                            id="header"
                            value={layout.header.regra}
                            onChange={onChangeLayoutRegra}
                            label="Regra"
                            size='small'
                            variant="outlined"
                            sx={{ width: '20ch', ml: 2 }}
                            helperText="Regra de acesso a pagina"
                        />
                    </div>
                    <div>
                        <TextField
                            value={layout.left.pagina}
                            id="left"
                            sx={{ width: '70%' }}
                            onChange={onChangeLayout}
                            label="Left" size='small' variant="outlined" fullWidth
                            helperText="Indique nome da pagina da lateral esquerda"
                        />
                        <TextField
                            id="left"
                            value={layout.left.regra}
                            onChange={onChangeLayoutRegra}
                            label="Regra"
                            size='small'
                            variant="outlined"
                            sx={{ width: '20ch', ml: 2 }}
                            helperText="Regra de acesso a pagina"
                        />
                    </div>
                    <div>
                        <TextField
                            value={layout.body.pagina}
                            id="body"
                            onChange={onChangeLayout}
                            sx={{ width: '70%' }}
                            label="Body" size='small' variant="outlined" fullWidth
                            helperText="Indique nome da pagina do corpo da aplicação"
                        />
                        <TextField
                            id="body"
                            value={layout.body.regra}
                            onChange={onChangeLayoutRegra}
                            label="Regra"
                            size='small'
                            variant="outlined"
                            sx={{ width: '20ch', ml: 2 }}
                            helperText="Regra de acesso a pagina"
                        />
                    </div>
                    <div>
                        <TextField
                            value={layout.rigth.pagina}
                            id="rigth"
                            onChange={onChangeLayout}
                            sx={{ width: '70%' }}
                            label="Right" size='small' variant="outlined" fullWidth
                            helperText="Indique nome da pagina da lateral direita"
                        />
                        <TextField
                            id="rigth"
                            value={layout.rigth.regra}
                            onChange={onChangeLayoutRegra}
                            label="Regra"
                            size='small'
                            variant="outlined"
                            sx={{ width: '20ch', ml: 2 }}
                            helperText="Regra de acesso a pagina"
                        />
                    </div>
                    <div>
                        <TextField
                            value={layout.footer}
                            id="footer"
                            onChange={onChangeLayout}
                            sx={{ width: '70%' }}
                            label="Right" size='small' variant="outlined" fullWidth
                            helperText="Indique nome da pagina da lateral direita"
                        />
                        <TextField
                            id="headerRegra"
                            value={layout.rigth.regra}
                            onChange={onChangeLayout}
                            label="Regra"
                            size='small'
                            variant="outlined"
                            sx={{ width: '20ch', ml: 2 }}
                            helperText="Regra de acesso a pagina"
                        />
                    </div>
                </Stack>
            )
        }
        if (layout.tipo === 'linha') {
            return (
                <Stack spacing={2} sx={{ width: '100%' }} >
                    <TextField
                        label="Linha"
                        size='small'
                        variant="outlined"
                        fullWidth
                        value={layout.linha}
                        id="linha"
                        onChange={onChangeLayout}
                        helperText="Indique nome das paginas"
                    />
                    <Typography>
                        A quantidade de pagina vai indicar o numero de linhas
                    </Typography>
                </Stack>
            )
        } else if (layout.tipo === 'coluna') {
            return (
                <Stack spacing={2} sx={{ width: '100%' }} >
                    <TextField
                        label="Coluna"
                        size='small'
                        variant="outlined"
                        fullWidth
                        value={layout.coluna}
                        id="coluna"
                        onChange={onChangeLayout}
                        helperText="Indique nome das paginas"
                    />
                    <Typography>
                        A quantidade de pagina vai indicar o numero de linhas
                    </Typography>
                </Stack>
            )
        }
        return (
            <p>não implementado {layout.tipo} </p>
        )
    }
    return (
        <Grid container spacing={2}>
            <Grid size={4}>
                <Stack>
                    <Typography>
                        Escolha qual layout:
                    </Typography>
                    <Card variant="outlined" style={{ width: '320px' }}>
                        <MyCardAction action={handleClick} name='portal' tipo={layout.tipo} >
                            <CardContent>
                                <div className='portal'>
                                    <div id="pageHeader"
                                        style={{ background: 'blue', height: '20px', width: '300px', textAlign: 'center' }}
                                    >
                                        Header
                                    </div>
                                    <div id="mainArticle"
                                        style={{ background: 'green', height: '100%', textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                                    >
                                        Body
                                    </div>
                                    <div id="mainNav"
                                        style={{ background: 'yellow', height: '120px', textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                                    >
                                        Left
                                    </div>
                                    <div id="siteAds"
                                        style={{ background: 'yellow', height: '120px', textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                                    >
                                        Right
                                    </div>
                                    <div id="pageFooter" style={{ background: 'cyan', height: '20px', textAlign: 'center' }}>Footer</div>
                                </div>
                            </CardContent>
                        </MyCardAction>
                    </Card>

                    <Card variant="outlined" style={{ width: '320px' }}>
                        <MyCardAction action={handleClick} name='linha' tipo={layout.tipo}>
                            <CardContent>
                                <Stack spacing={2} style={{ height: '180px', }}>
                                    <div style={{ background: 'cyan', height: '100%', width: '100%', textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>Linha1</div>
                                    <div style={{ background: 'green', height: '100%', width: '100%', textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>Linha2</div>
                                    <div style={{ background: 'blue', height: '100%', width: '100%', textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>Linha3</div>
                                </Stack>
                            </CardContent>
                        </MyCardAction>
                    </Card>
                    <Card variant="outlined" style={{ width: '320px' }}>
                        <MyCardAction action={handleClick} name='coluna' tipo={layout.tipo}>
                            <CardContent>
                                <Stack direction="row" spacing={2} style={{ height: '180px' }}>
                                    <div style={{ background: 'cyan', height: '100%', width: '100%', textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex' }} >Coluna1</div>
                                    <div style={{ background: 'green', height: '100%', width: '100%', textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>Coluna2</div>
                                    <div style={{ background: 'blue', height: '100%', width: '100%', textAlign: 'center', alignItems: 'center', justifyContent: 'center', display: 'flex' }} >Coluna3</div>
                                </Stack>
                            </CardContent>
                        </MyCardAction>
                    </Card>
                </Stack>

            </Grid>
            <Grid size={8}>
                <Box sx={{
                    my: 4
                }} >
                    <Typography>Tipo: {layout.tipo}</Typography>
                </Box>
                <Box
                    sx={{
                        alignItems: "center",
                        p: 2,
                        border: '2px solid grey'
                    }}>

                    {MontaFormTipo()}
                </Box>
            </Grid>
        </Grid>
    );
});

export default TipoLayout;
